export const ONBOARDING_FINISHED = 'ONBOARDING_FINISHED';
export const START_SCREEN_SHOWED = 'START_SCREEN_SHOWED';
export const QR_CODE_SCREEN_SHOWED = 'QR_CODE_SCREEN_SHOWED';
export const QR_CODE_SCREEN_HIDED = 'QR_CODE_SCREEN_HIDED';
